<template>
  <svg width="40" height="40" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5 16.918V33.0753C20.1263 36.8921 29.8737 36.8921 38.5 33.0753V16.918C29.8719 13.1102 20.1281 13.1102 11.5 16.918ZM10.4477 15.6898C19.7194 11.4367 30.2806 11.4367 39.5523 15.6898C39.8244 15.8146 40 16.095 40 16.4046V33.5881C40 33.8974 39.8247 34.1776 39.553 34.3026C30.2828 38.5658 19.7172 38.5658 10.447 34.3026C10.1753 34.1776 10 33.8974 10 33.5881V16.4046C10 16.095 10.1756 15.8146 10.4477 15.6898Z"
      :fill="pathFill"
    />
    <path
      d="M29.6135 26.9371C29.6135 24.3446 27.5052 22.2305 24.9068 22.2305C22.3143 22.2305 20.2002 24.3387 20.2002 26.9371C20.2002 29.5355 22.3084 31.6437 24.9068 31.6437C27.4993 31.6437 29.6135 29.5355 29.6135 26.9371ZM21.8715 26.9371C21.8715 25.26 23.2357 23.9017 24.9069 23.9017C26.5781 23.9017 27.9423 25.2659 27.9423 26.9371C27.9423 28.6083 26.5781 29.9725 24.9069 29.9725C23.2357 29.9725 21.8715 28.6143 21.8715 26.9371Z"
      :fill="pathFill"
    />
    <path
      d="M25.0329 19.8468C25.4935 19.8468 25.8655 19.4748 25.8655 19.0141V18.0338C25.8655 17.5732 25.4935 17.2012 25.0329 17.2012C24.5722 17.2012 24.2002 17.5732 24.2002 18.0338V19.0141C24.2002 19.4748 24.5722 19.8468 25.0329 19.8468Z"
      :fill="pathFill"
    />
  </svg>
</template>
<script>
export default {
  props: {
    pathFill: {
      type: String,
      default: '#F6F8F8',
    },
  },
};
</script>
